import * as bootstrap from 'bootstrap';

export default ($) => {

    $( ".hero-model__reviews-count" ).on( "click", function(e) {
		const scrollIntoViewWithOffset = (selector, offset) => {
			window.scrollTo({
			  behavior: 'smooth',
			  top:
				document.querySelector(selector).getBoundingClientRect().top -
				document.body.getBoundingClientRect().top -
				offset,
			})
		}

		var myCollapseEl = document.getElementById('bv-block-reviews');
		var bsCollapse = bootstrap.Collapse.getOrCreateInstance(myCollapseEl);
		bsCollapse.show();
		scrollIntoViewWithOffset('#bv-block-reviews', document.querySelector("header.header").offsetHeight + 10 );
		e.preventDefault();

	});
}